var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view"},[_c('order-details'),_c('b-row',[_c('b-col',{attrs:{"sm":"7","md":"6","lg":"5","xl":"4"}},[_c('orders-list')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }